export default "__VITE_ASSET__4479fc96__"